// extracted by mini-css-extract-plugin
var _1 = "ApplicantNotesBlock-moduleApplicantNotesBlock__MO99B";
var _2 = "ApplicantNotesBlock-moduleeditButton__kaFA8";
var _3 = "ApplicantNotesBlock-moduleeditWrapper__dz67X";
var _4 = "ApplicantNotesBlock-moduleeditableNoteRow__NXQ49";
var _5 = "ApplicantNotesBlock-modulenote__nLpiQ";
var _6 = "ApplicantNotesBlock-modulenoteRow__gYuab";
var _7 = "ApplicantNotesBlock-modulepersistentEditButton__vHZhz";
export { _1 as "ApplicantNotesBlock", _2 as "editButton", _3 as "editWrapper", _4 as "editableNoteRow", _5 as "note", _6 as "noteRow", _7 as "persistentEditButton" }
